import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';
import * as mixpanel from 'mixpanel-browser';

@Injectable({
    providedIn: 'root'
})
export class MixpanelService {

    constructor(
        @Inject(PLATFORM_ID) private platform: Object
    ) { }

    /**
     * Initialize mixpanel.
     *
     * @memberof MixpanelService
     */
    init(enableDebug: boolean = false): void {
        mixpanel.init(environment.mixpanel.project_token, {debug: enableDebug});
    }

    /**
     * Initialize mixpanel.
     *
     * @param {string} userId
     * @memberof MixpanelService
     */
     identify(userId: string): void {
        mixpanel.identify(userId);
    }

    /**
     * Alias user with mixpanel distinct_id.
     *
     * @param {string} userId
     * @memberof MixpanelService
     */
    alias(userId: string): void {
        mixpanel.alias(userId, mixpanel.get_distinct_id());
    }

    /**
     * Push new properties to mixpanel.
     *
     * @param {string} id Name of the properties to track.
     * @param {*} [properties={}] Custom properties object.
     * @memberof MixpanelService
     */
    track(id: string, properties: any = {}): void {
        mixpanel.track(id, properties);
    }

    /**
     * Clears super properties and generates a new random distinct_id for this instance.
     * Useful for clearing data when a user logs out.
     *
     * @memberof MixpanelService
     */
     reset(){
        mixpanel.reset();
    }

    /**
     * Set properties on a user record.
     *
     * @param {string} id Name of the properties to track.
     * @param {*} [properties={}] Custom properties object.
     * @memberof MixpanelService
     */
    peopleSet(id:string, properties: any = {}){

        this.identify(id);

        mixpanel.people.set(properties);
    }
}
